import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, TemplateRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { BaseService } from "./base.service";

@Injectable()
export class NotificationService extends BaseService<any> {
	currentLanguage;
	// notifications are for user
	public _messagesCount$ = new BehaviorSubject<number>( 0 );
	public _notifications$ = new BehaviorSubject<any>( [] );

	// activities are for whole organization
	public _activities$ = new BehaviorSubject<any>( [] );

	constructor(
		private notification: NzNotificationService,
		private translationService: TranslateService,
		private httpClient: HttpClient,
		@Inject(HttpClient) http )
	{
		super(http);
		this.notification = notification;
		this.translationService = translationService;
		this.httpClient = httpClient;

		this.currentLanguage = this.translationService.currentLang;
		this.translationService.onLangChange.subscribe( response => {
			this.currentLanguage = response.lang;
		} );
	}

	ngOnInit() {
		console.info( "init ads" );
		this.getProfileNotifications(false);
	}

	get messagesCount$(): Observable<number> {
		return this._messagesCount$.asObservable();
	}

	get notifications$() {
		return this._notifications$.asObservable();
	}

	get activities$() {
		return this._activities$.asObservable();
	}

	/**
	 *	Display success notification
	 * @param title : title of the notification
	 * @param description : description of the notification
	 */
	successNotification( key: string ): void {
		this.translationService.getTranslation( this.currentLanguage ).subscribe( response => {
			const notificationTitle = response.global["notifications"]["success"]["title"][key];
			const notificationDescription = response.global["notifications"]["success"]["description"][key];
			this.notification.success( notificationTitle, notificationDescription );
		} );
	}

	/**
	 *	Display failure notification
	 * @param title : title of the notification
	 * @param description : description of the notification
	 */
	failureNotification( key: string, optional?: any ): void {
		this.translationService.getTranslation( this.currentLanguage ).subscribe( response => {
			const notificationTitle = response.global["notifications"]["failed"]["title"][key];
			const notificationDescription = response.global["notifications"]["failed"]["description"][key];
			optional ? notificationDescription + ` ${optional}` : "";
			this.notification.error( notificationTitle, notificationDescription );
		} );
	}

	/**
	 *	Display notification with confirm button
	 * @param template: template reference for a custom element
	 */
	notificationWithConfirmation( template: TemplateRef<{}>, data?: object ): void {
		this.notification.template( template, { nzData: data } );
	}

	public async getProfileNotifications(isLoadMore: boolean,isDeleted:boolean=false) {
		if(isDeleted)
		{
			this._isLoading$.next(true);
		}
		let URI: string = environment.API_ENDPOINT + environment.VERSION_V1;
		// change supplier route
		URI += `/core/notifications?isLoadMore=${isLoadMore}`;
		this.httpClient.get( URI ).subscribe( ( response: any ) => {
			if(isDeleted)
			{
				this._isLoading$.next(false);
			}
			this._notifications$.next( response.items || [] );
			this._messagesCount$.next( response.total || 0 );
		}, ( error: any ) => {
			if(isDeleted)
			{
				this._isLoading$.next(false);
			}
			console.error( error );
		} );
	}

	public getAllActivities( ) {
		let URI: string = environment.API_ENDPOINT + environment.VERSION_V1;
		// change supplier route
		URI += "/core/activities";
		this.post( URI, {} ).subscribe( ( response: any ) => {
			this._activities$.next( response.items || [] );
		}, ( error: any ) => {
			console.error( error );
		} );
	}

	public markAllNotificationsAsRead( ) {
		let URI: string = environment.API_ENDPOINT + environment.VERSION_V1;
		// change supplier route
		URI += "/core/notifications";
		this.put( URI, {} ).subscribe( ( ) => {
			this.getProfileNotifications(false,true);
		}, ( error: any ) => {
			console.error( error );
		} );
	}
}
